// extracted by mini-css-extract-plugin
export default {"elements":"email-verifying_elements__FwoCI","spinnerContent":"email-verifying_spinnerContent__TwFOp"};